import * as d3 from "d3";

const parse_time = d3.timeParse("%Y-%m-%dT%H:%M:%S.%LZ");
const parse_entry_date = d3.timeParse("%m/%d/%Y");

const filterFunctions = {
  timePeriod: (d, sel, currentDate) => {
    if (sel === "12 Months") {
      const year = parse_time(currentDate).getFullYear();
      const aDate = d3.timeFormat("%m/%d")(parse_time(currentDate));
      return (
        parse_entry_date(d.dateofincident) >=
        parse_entry_date(`${aDate}/${year - 1}`)
      );
    }
    return parse_entry_date(d.dateofincident).getFullYear() === +sel;
  },
  ageRange: (d, age) => {
    return d.age >= age[0] && d.age <= age[1];
  },
  communityArea: (d, communityArea) => {
    if (communityArea) {
      return d.communityarea === communityArea;
    } else {
      return true;
    }
  },
  race: (d, race) => {
    if (race === "All") {
      return true;
    } else {
      return d.raceethnicity.toLowerCase().trim() === race;
    }
  },
  cause: (d, cause) => {
    if (cause === "All") {
      return true;
    } else {
      return d.incidenttype.toLowerCase() === cause;
    }
  },
  sex: (d, sex) => {
    if (sex.male && sex.female) {
      return true;
    } else {
      let isVisible = false;
      if (sex.male && d.gender === "M") {
        isVisible = true;
      }
      if (sex.female && d.gender === "F") {
        isVisible = true;
      }
      return isVisible;
    }
  },
  month: (d, month) => {
    if (month !== "All") {
      return d3.timeFormat("%B")(parse_entry_date(d.dateofincident)) === month;
    } else {
      return true;
    }
  },
};

export default filterFunctions;
